import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  PageActions,
  TextField,
  FormLayout,
  Select,
  Toast,
  Loading,
  Checkbox,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import TagsInput from "react-tagsinput";

export const EditWorkflow = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(true);
  const [nameValue, setNameValue] = useState("");
  const handleChangeName = (newValue) => {
    setItem({ ...item, name: newValue });
    setNameError("");
  };
  const [descriptionValue, setDescriptionValue] = useState("");
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };
  const [nameError, setNameError] = useState("");
  const [selectedTrigger, setSelectedTrigger] = useState("");
  const handleSelectChangeTrigger = (newValue) => {
    setItem({ ...item, trigger: newValue });
    setTriggerError("");
  };
  const optionsTrigger = [
    { label: "Contact us", value: "1" },
    { label: "Subscribe", value: "2" },
  ];
  const [triggerError, setTriggerError] = useState("");

  const [selectedAction, setSelectedAction] = useState("1");
  const handleSelectChangeAction = (newValue) => {
    setItem({ ...item, action: newValue });
    setActionError("");
  };
  const optionsAction = [
    { label: "Send Email to contact", value: "1" },
    { label: "Send Email internally", value: "2" },
  ];
  const [actionError, setActionError] = useState("");

  const [active, setActive] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const handleChangeIsActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [recipients, setRecipients] = useState([]);
  const handleChangeRecipients = (recipients) => {
    setItem({ ...item, recipients: recipients });
  };
  const [item, setItem] = useState({
    name: "",
    trigger: "",
    action: "",
    isActive: "",
    recipients: [],
  });
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseWorflow = "";

    try {
      responseWorflow = await axios.get(`/crm/workflows/${id}`);
      console.log(responseWorflow.data.data.name);
      setItem({
        name: responseWorflow?.data?.data?.name
          ? responseWorflow.data.data.name
          : "",
        description: responseWorflow?.data?.data?.description
          ? responseWorflow.data.data.description
          : "",
        trigger:
          responseWorflow?.data?.data?.trigger &&
          responseWorflow?.data?.data?.trigger?.id !== null
            ? String(responseWorflow.data.data.trigger.id)
            : "",
        action:
          responseWorflow?.data?.data?.action &&
          (responseWorflow?.data?.data?.action?.id !== null) !== null
            ? String(responseWorflow.data.data.action.id)
            : "",
        isActive: responseWorflow?.data?.data?.is_active ? true : false,
        recipients:
          responseWorflow?.data?.data?.recipients &&
          responseWorflow?.data?.data?.recipients.length
            ? responseWorflow?.data?.data?.recipients
            : [],
      });
    } catch (error) {
      console.log(error);
    }
    setIsSaving(false);
  }

  return (
    <Page
      title="Edit Workflow"
      narrowWidth
      breadcrumbs={[{ onAction: () => navigate(`/admin/crm/automation`) }]}
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="Name"
              value={item.name}
              onChange={handleChangeName}
              error={nameError}
            />
            <TextField
              label="Description"
              value={item.description}
              onChange={handleChangeDescription}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Trigger"
              options={optionsTrigger}
              onChange={handleSelectChangeTrigger}
              value={item.trigger}
              error={triggerError}
              placeholder="Please select"
            />
            <Select
              label="Action"
              options={optionsAction}
              onChange={handleSelectChangeAction}
              value={item.action}
              error={actionError}
            />
          </FormLayout.Group>
          {item.action === "2" && (
            <div>
              <Text as="p" fontWeight="regular">
                Recipients
              </Text>
              <TagsInput
                value={item.recipients}
                onChange={handleChangeRecipients}
                inputProps={{
                  placeholder:
                    "Enter recipient email here and use the Enter key to add multiple emails",
                }}
              />
            </div>
          )}
          <Checkbox
            label="Is Active"
            checked={item.isActive}
            onChange={handleChangeIsActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={[
          {
            content: "Delete",
            destructive: true,
            loading: isSaving && true,
            onClick: () => {
              setIsSaving(true);
              axios
                .delete(`/crm/workflows/${id}`)
                .then((result) => {
                  navigate("/admin/crm/automation");
                })
                .catch((err) => console.log(err));
            },
          },
        ]}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (!item.name) {
      !nameValue && setNameError("This field is required");
    } else {
      setIsSaving(true);
      const bodyObj = {
        name: item.name,
        description: item.description,
        trigger: item.trigger,
        action: item.action,
        is_active: item.isActive ? 1 : 0,
        recipients: item.recipients,
      };
      axios
        .patch(`/crm/workflows/${id}`, bodyObj)
        .then((res) => {
          setIsSaving(false);
          navigate("/admin/crm/automation");
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActive();
            setIsSaving(false);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};
